import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

import { API_URL } from '../constants/api';
import { ENDPOINTS } from '../constants/api';
import { groupBy } from '../utlis';
import { APP_NAME, APP_VERSION, APP_LOGO } from '../constants/index';
import { decodeToken, getToken } from '../utils/TokenUtils';
import ModalForm from './ModalForm';
import FeatherIcon from 'feather-icons-react';

export default function Navbar() {
  const navigate = useNavigate();
  const token = getToken();
  const userId = decodeToken(token, 'id');
  const userImage = decodeToken(token, 'image');
  const userEmail = decodeToken(token, 'email');
  const userName = decodeToken(token, 'name');
  const companyName = decodeToken(token, 'companyName');
  const companyLogo = decodeToken(token, 'logo');
  const loginPage = decodeToken(token, 'loginPage');
  const passwordExpireLeft = decodeToken(token, 'passwordExpireLeft');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalProps, setModalProps] = useState({
    userId: null,
    token: null,
    route: null,
  });

  console.log(token);
  // Function to open the modal with dynamic props
  const handleOpenModal = (e, route) => {
    e.preventDefault();

    setModalProps({ userId, token, route });
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [links, setLinks] = useState([]);

  useEffect(() => {
    const linksUrl = `${API_URL}/${ENDPOINTS.SYS}/getlinks`;

    const fetchLinks = async (url) => {
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        setLinks(groupBy(response.data, 'category'));
        //  console.log(response.data);
      } catch (error) {
        // console.log("Error fetching links ", error, "url: ", url)
      }
    };

    fetchLinks(linksUrl);
  }, []);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(`${API_URL}/api/users/logout`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log('res', response, 'token:', token);

      // Remove token from localStorage
      localStorage.removeItem('authToken');
      navigate(`/login/${loginPage}`);
    } catch (error) {
      console.error('Error fetching data:', error);
      // Remove token from localStorage

      //  localStorage.removeItem("token");
      //  navigate("/login");
    }
  };

  return (
    <>
      {/* ModalForm component */}
      <ModalForm
        userId={modalProps.userId}
        token={modalProps.token}
        route={modalProps.route}
        isOpen={isModalOpen}
        onRequestClose={closeModal}
      />
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          {/* Brand */}
          <img
            src={`${API_URL}/${companyLogo}`}
            width="50px"
            alt="Company Logo"
            className="rounded-circle"
          />{' '}
          &nbsp;
          <Link className="navbar-brand fw-bold" to="/dashboard">
            {companyName}
          </Link>
          {/* Toggler button */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          {/* Navbar links */}
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto">
              {Object.entries(links).map(([category, items]) => (
                <li key={category} className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle fw-bold"
                    href="/"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <FeatherIcon icon={items[0].category_icon} /> {category}
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    {items.map((item) => (
                      <li key={item.id}>
                        <Link
                          className="dropdown-item fw-bold"
                          to={`/${item.full_route}`}
                        >
                          <FeatherIcon icon={item.icon} /> {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>

            {/* User Profile Dropdown */}
            <ul className="navbar-nav ms-auto">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="/"
                  id="userDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src={`${API_URL}/${userImage}`}
                    alt="User"
                    className="rounded-circle"
                    style={{ width: '30px', height: '30px' }}
                  />{' '}
                  &nbsp;&nbsp;
                  {userName}
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="userDropdown"
                >
                  <li>
                    <Link className="dropdown-item" to="/profile">
                      Profile
                    </Link>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="/"
                      onClick={(e) => handleOpenModal(e, 'change-password')}
                    >
                      Change Password
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="/logout"
                      onClick={(e) => handleLogout(e)}
                    >
                      Logout
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={`${API_URL}/${ENDPOINTS.SYS}/backup`}
                      target="_blank"
                      rel="noreferrer"
                      // onClick={(e) => handleLogout(e)}
                    >
                      Backup
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {passwordExpireLeft !== null && passwordExpireLeft < 15 && (
        <p className="text-danger text-center fw-bold">
          <marquee>
            Your password will expire soon, it only remains {passwordExpireLeft}{' '}
            days, please{' '}
            <a href="/" onClick={(e) => handleOpenModal(e, 'change-password')}>
              change
            </a>{' '}
            before it expires.
          </marquee>
        </p>
      )}
    </>
  );
}
